module.exports = __webpack_public_path__ + "static/media/service_body_p01.4f84f15e.webp";